import { __assign, __awaiter, __generator } from "tslib";
import { HttpRequest } from "@aws-sdk/protocol-http";

var isClockSkewed = function isClockSkewed(newServerTime, systemClockOffset) {
  return Math.abs(getSkewCorrectedDate(systemClockOffset).getTime() - newServerTime) >= 300000;
};

var getSkewCorrectedDate = function getSkewCorrectedDate(systemClockOffset) {
  return new Date(Date.now() + systemClockOffset);
};

export function awsAuthMiddleware(options) {
  return function (next, context) {
    return function (args) {
      return __awaiter(this, void 0, void 0, function () {
        var signer, _a, output, _b, _c, headers, dateHeader, serverTime;

        var _d;

        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              if (!HttpRequest.isInstance(args.request)) return [2
              /*return*/
              , next(args)];
              if (!(typeof options.signer === "function")) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , options.signer()];

            case 1:
              _a = _e.sent();
              return [3
              /*break*/
              , 3];

            case 2:
              _a = options.signer;
              _e.label = 3;

            case 3:
              signer = _a;
              _b = next;
              _c = [__assign({}, args)];
              _d = {};
              return [4
              /*yield*/
              , signer.sign(args.request, {
                signingDate: new Date(Date.now() + options.systemClockOffset),
                signingRegion: context["signing_region"],
                signingService: context["signing_service"]
              })];

            case 4:
              return [4
              /*yield*/
              , _b.apply(void 0, [__assign.apply(void 0, _c.concat([(_d.request = _e.sent(), _d)]))])];

            case 5:
              output = _e.sent();
              headers = output.response.headers;
              dateHeader = headers && (headers.date || headers.Date);

              if (dateHeader) {
                serverTime = Date.parse(dateHeader);

                if (isClockSkewed(serverTime, options.systemClockOffset)) {
                  options.systemClockOffset = serverTime - Date.now();
                }
              }

              return [2
              /*return*/
              , output];
          }
        });
      });
    };
  };
}
export var awsAuthMiddlewareOptions = {
  name: "awsAuthMiddleware",
  tags: ["SIGNATURE", "AWSAUTH"],
  relation: "after",
  toMiddleware: "retryMiddleware"
};
export var getAwsAuthPlugin = function getAwsAuthPlugin(options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
    }
  };
};